import { Card } from "@/components/ui/card";
import { Quote, Star } from "lucide-react";
import SectionHeader from "./SectionHeader";

const TESTIMONIALS = [
  {
    name: "Suresh Iyer",
    role: "Plant Manager, Auto Components Pvt Ltd",
    quote:
      "RK Enterprises deployed 80 semi-skilled workers within a week of our request. Their workforce is disciplined and PF/ESI compliance is always handled on time.",
    rating: 5,
  },
  {
    name: "Priya Ramanathan",
    role: "HR Lead, Industrial Logistics Co.",
    quote:
      "We have been partnering with RK Enterprises for over 3 years. Their shift-based staffing model integrates seamlessly with our 24/7 operations.",
    rating: 5,
  },
  {
    name: "Karthik Murugan",
    role: "Operations Head, Housekeeping Services",
    quote:
      "Reliable, well-trained housekeeping staff with proper accommodation and supervision. RK is genuinely a long-term partner, not just a vendor.",
    rating: 5,
  },
  {
    name: "Anbarasan V.",
    role: "Worker — Factory Operations",
    quote:
      "Salary on time before the 8th every month, accommodation and meals are well managed. Bonus and increments are exactly as promised.",
    rating: 5,
  },
];

export default function Testimonials() {
  return (
    <section className="bg-white py-16 md:py-24" data-testid="testimonials-section">
      <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <SectionHeader
          eyebrow="What partners say"
          title="Trusted by companies and workers alike"
          description="Long-standing relationships built on compliance, discipline, and on-time deployment."
          testid="testimonials-header"
        />
        <div className="mt-12 grid grid-cols-1 md:grid-cols-2 gap-6">
          {TESTIMONIALS.map((t, idx) => (
            <Card
              key={idx}
              data-testid={`testimonial-card-${idx}`}
              className="rk-lift relative p-6 sm:p-8 bg-white border border-[#E2E8F0] rounded-sm"
            >
              <Quote className="absolute top-5 right-5 h-8 w-8 text-[#1F6B5C]/15" />
              <div className="flex items-center gap-1 mb-4">
                {Array.from({ length: t.rating }).map((_, i) => (
                  <Star
                    key={i}
                    className="h-4 w-4 fill-[#F59E0B] text-[#F59E0B]"
                  />
                ))}
              </div>
              <p className="text-[#0F172A] leading-relaxed">"{t.quote}"</p>
              <div className="mt-6 pt-5 border-t border-dashed border-[#E2E8F0]">
                <div className="font-display font-bold text-[#0F172A]">
                  {t.name}
                </div>
                <div className="text-sm text-[#64748B]">{t.role}</div>
              </div>
            </Card>
          ))}
        </div>
      </div>
    </section>
  );
}
